<section
  class="expansion-panel-wrapper"
  [attr.data-testid]="'expansion-panel-wrapper'"
  [ngStyle]="style"
  [ngClass]="isOpen ? 'content-expanded' : 'content-closed'"
>
  @if (headingLevel === 'h2') {
    <h2 class="expansion-panel-heading">
      <ng-container *ngTemplateOutlet="headingContent" />
    </h2>
  } @else if (headingLevel === 'h3') {
    <h3 class="expansion-panel-heading">
      <ng-container *ngTemplateOutlet="headingContent" />
    </h3>
  } @else {
    <h4 class="expansion-panel-heading">
      <ng-container *ngTemplateOutlet="headingContent" />
    </h4>
  }
  <div
    #contentWrapper
    class="content-wrapper"
    [id]="buttonId + '-panel'"
    [attr.aria-hidden]="!isOpen"
    [ngClass]="{
      'no-content-padding': !contentPadding,
      'no-content-border': !contentBorder,
      'no-clip': !clipContent,
    }"
  >
    <ng-content></ng-content>
  </div>
</section>

<ng-template #headingContent>
  <button
    (click)="onToggle()"
    [id]="buttonId + '-button'"
    class="expansion-panel-toggle"
    [disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="buttonId + '-panel'"
    [attr.disabled]="!toggleable ? true : null"
    [attr.data-cy]="'expansion-' + header"
    type="button"
  >
    <div class="header-left">
      <span class="expansion-panel-angle pi pi-angle-right"></span>
      <span *ngIf="header" class="header-text">{{ header }}</span>
      <span *ngIf="!header" class="header-text sr-only">
        {{ GLOBAL_STRINGS.GROUP | translateString: lang }}
      </span>
      <app-label-icon *ngIf="headerIcon" [data]="headerIcon" />
      <app-label-icon *ngIf="headerWarningIcon" [data]="headerWarningIcon" />
    </div>
    <div class="header-right"><ng-content select="[headerContentRight]"></ng-content></div>
  </button>
</ng-template>
